import * as React from "react"

export type BreakpointType = 'mobile' | 'tablet' | 'desktop'

interface BreakpointConfig {
  mobile: { max: number }
  tablet: { min: number; max: number }
  desktop: { min: number }
}

const BREAKPOINTS: BreakpointConfig = {
  mobile: { max: 639 }, // < 640px
  tablet: { min: 640, max: 1023 }, // 640px - 1023px
  desktop: { min: 1024 } // >= 1024px
}

export function useResponsiveBreakpoint(): BreakpointType {
  const [breakpoint, setBreakpoint] = React.useState<BreakpointType>('desktop')

  React.useEffect(() => {
    const updateBreakpoint = () => {
      const width = window.innerWidth
      
      if (width <= BREAKPOINTS.mobile.max) {
        setBreakpoint('mobile')
      } else if (width >= BREAKPOINTS.tablet.min && width <= BREAKPOINTS.tablet.max) {
        setBreakpoint('tablet')
      } else {
        setBreakpoint('desktop')
      }
    }

    // Set initial breakpoint
    updateBreakpoint()

    // Listen for resize events
    window.addEventListener('resize', updateBreakpoint)
    
    return () => window.removeEventListener('resize', updateBreakpoint)
  }, [])

  return breakpoint
}

// Keep original hook for backward compatibility
export function useIsMobile() {
  const breakpoint = useResponsiveBreakpoint()
  return breakpoint === 'mobile'
}

// Additional helper hooks
export function useIsTablet() {
  const breakpoint = useResponsiveBreakpoint()
  return breakpoint === 'tablet'
}

export function useIsDesktop() {
  const breakpoint = useResponsiveBreakpoint()
  return breakpoint === 'desktop'
}
